import * as axios from "axios";

//const BASE_URL = "https://api.cryptodok.wiam.ru";
 const BASE_URL = window.$api_url.substr(0, window.$api_url.length - 1);//) "http://api.localdoc.ru";

axios.defaults.headers.common.Authorization = `CryptoDoc ${localStorage.getItem("user-token")}`;
axios.defaults.timeout = 360000;

function uploadDocument(formData, { inn }) {
    const url = `${BASE_URL}/v1/files`;
    const params = inn ? { inn } : "";

    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }, params
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadPackageDocument(formData, { packageMode, uploadFolderId }) {
    const url = `${BASE_URL}/v1/package/${packageMode}/document/${uploadFolderId}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadCustomPackageDocument(formData, { packageMode, uploadFolderId }) {
    const url = `${BASE_URL}/v1/package/${packageMode}/custom-document/${uploadFolderId}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadPublicDocument(formData, { hash }) {
    const url = `${BASE_URL}/v1/files/create-public-hash/${hash}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadLicence(formData, { inn }) {
    const url = `${BASE_URL}/v1/files`;
    const params = inn ? { inn } : "";
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }, params
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadPackageLicence(formData, { packageId, licenceId }) {
    const url = `${BASE_URL}/v1/package/${packageId}/licence/${licenceId}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadBankTemplate(formData, packageId, bankItemId) {
    const url = `${BASE_URL}/v1/package/${packageId}/bank-item/${bankItemId}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadBankItem(formData, { packageId, bankItemId }) {
    const url = `${BASE_URL}/v1/package/${packageId}/bank-item/${bankItemId}`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadChatFile(formData, packageId) {
    const url = `${BASE_URL}/v1/package/${packageId}/history-add`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadTaskFile(formData, task) {
    console.log(task, "taskk")
    const url = `${BASE_URL}/v1/comments`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            return x.data;
        })
        .catch(error => {
            return error;
        });
}

function uploadTenders(formData) {
    const url = `${BASE_URL}/v1/tenders/import?key=32_9dsazpqe6`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            console.log(x, "then in uploadTenders");
            return x;
        })
        .catch(error => {
            console.log(error, "catch in uploadTenders");
            return error;
        });
}


function uploadFile(formData) {
    const url = `${BASE_URL}/v1/files/upload`;
    return axios
        .post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(x => {
            console.log(x, "then in uploadFile");
            return x;
        })
        .catch(error => {
            console.log(error, "catch in uploadFile");
            return error;
        });
}

export {
    uploadDocument,
    uploadPackageDocument,
    uploadCustomPackageDocument,
    uploadPublicDocument,
    uploadLicence,
    uploadPackageLicence,
    uploadBankTemplate,
    uploadBankItem,
    uploadChatFile,
    uploadTaskFile,
    uploadTenders,
    uploadFile
};
